/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resources_Order_NameInputs */

const en_resources_order_name = /** @type {(inputs: Resources_Order_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orders`)
};

const fr_resources_order_name = /** @type {(inputs: Resources_Order_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commandes`)
};

const es_resources_order_name = /** @type {(inputs: Resources_Order_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedidos`)
};

const de_resources_order_name = /** @type {(inputs: Resources_Order_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestellungen`)
};

const nl_resources_order_name = /** @type {(inputs: Resources_Order_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestellingen`)
};

/**
* | output |
* | --- |
* | "Orders" |
*
* @param {Resources_Order_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "de" | "nl" }} options
* @returns {LocalizedString}
*/
const resources_order_name = /** @type {((inputs?: Resources_Order_NameInputs, options?: { locale?: "en" | "fr" | "es" | "de" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resources_Order_NameInputs, { locale?: "en" | "fr" | "es" | "de" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_resources_order_name(inputs)
	if (locale === "fr") return fr_resources_order_name(inputs)
	if (locale === "es") return es_resources_order_name(inputs)
	if (locale === "de") return de_resources_order_name(inputs)
	return nl_resources_order_name(inputs)
});
export { resources_order_name as "resources.order.name" }